<template>
  <div>
    <div class="mb-4">
      <h3 class="page-header-2">Link Answered Calls</h3>
      <active-call-link-buttons
        :linked-calls="linkedCalls"
        @link-call="emitLinkCall"
      ></active-call-link-buttons>
    </div>
    <div class="mb-4 call-lookup">
      <h3 class="page-header-2">Search and Link an Old or Missed Call</h3>
      <inactive-call-lookup
        source="/reports/calls.json"
        :filters="filters"
      ></inactive-call-lookup>
    </div>
    <div class="mt-4 linked-call-table">
      <linked-calls-datatable
        :filters="filters"
        flat
        source="/reports/calls.json"
      ></linked-calls-datatable>
    </div>
  </div>
</template>

<script>
import ActiveCallLinkButtons from "@/CallComponents/ActiveCallLinkButtons.vue";
import InactiveCallLookup from "@/CallComponents/InactiveCallLookup.vue";
import LinkedCallsDatatable from "@/CallComponents/LinkedCallsDatatable.vue";

export default {
  components: {
    ActiveCallLinkButtons,
    InactiveCallLookup,
    LinkedCallsDatatable
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    linkedCalls: {
      type: Array,
      default: () => []
    },
    linkableType: {
      type: String,
      default: () => "Job"
    },
    linkableId: {
      type: Number,
      default: () => null
    }
  },
  emits: ["link-call"],
  methods: {
    emitLinkCall(callId) {
      this.$emit("link-call", callId);
    }
  }
};
</script>

<style lang="scss" scoped>
.linked-call-table {
  position: relative;
  z-index: 1;
}
.call-lookup {
  position: relative;
  z-index: 2;
}
</style>
